import { api } from 'app/config/apiConfig';
import { BoxDiscountsParams, Discount } from '../model/types';

export const getBoxDiscountsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBoxDiscounts: build.query<Discount[], BoxDiscountsParams>({
      query: (params) => ({
        url: `/boxes/${params.boxId}/discounts`,
        params,
      }),
    }),
  }),
});

export const { useGetBoxDiscountsQuery } = getBoxDiscountsApi;
